import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { object } from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor() { }

  generateCSV(data: any, section: any) {
    let csv = new Array();
    switch (section){
      case 'Partners':
        const showPartnerHeaders = ['Name','Email', 'Active','Type'];
        csv = csv.concat(showPartnerHeaders.join(','));
        //csv = csv.concat(this.objectToCsvHeader(data[0].partner) + ',type');
        data.forEach(item => {
          const dataArr = [item.partner.name, item.partner.email, item.partner.active, item.type];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'Projects':
        const showProjectHeaders = ['Name','Code', 'Description','Country', 'Active','Student count', 
        'Teacher count','Project admin count','School count'];
        csv = csv.concat(showProjectHeaders.join(','));
        data.forEach(item => {
          let description='';
          if(item.description){
            description = '"'+item.description+'"'; 
          }
          const dataArr = [item.name, item.code, description, item.country.name, item.active, item.studentCount,
            item.teacherCount, item.padminCount,item.schoolCount];
            csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'Projectadmin':
        const showHeaders = ['Name', 'Role', 'Organization', 'Email address', 'Username'];
        csv = csv.concat(showHeaders.join(','));
        data.forEach((item) => {
          const dataArr = [item.name, item.role.desc, item.partner.name, item.contact.email, item.username];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'Schools':
        const showSchoolHeaders = ['Name', 'Category', 'Region', 'Students', 'Teachers', 'CTL code', 'Status'];
        csv = csv.concat(showSchoolHeaders.join(','));
        data.forEach((item) => {
          const status = (item.active === true) ? 'Active' : 'Archived';
          const dataArr = [item.name, item.category.name, item.region.name, item.studentCount, item.teacherCount, item.code, status];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'ContentAll':
        this.downloadContentCsv(data, section, 'all');
        break;
      case 'FavContent':
        this.downloadContentCsv(data, section, 'fav');
        break;
      case 'MyContent':
        this.downloadContentCsv(data, section, 'all');
        break;
      case 'Groups':
        const showGroupHeaders = ['Group name', 'Students', 'Class', 'Description'];
        csv = csv.concat(showGroupHeaders.join(','));
        const classInfo = JSON.parse(localStorage.getItem('sessionDataForClass'));
        data.forEach((item) => {
          const dataArr = [item.name, item.students.length, classInfo.name , item.description];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'Students':
        const showStudentHeaders = ['Student name', 'Gender', 'Date of birth', 'Class', 'Grade', 'Status'];
        csv = csv.concat(showStudentHeaders.join(','));
        data.forEach((item) => {
          const status = (item.active === true) ? 'Active' : 'Archived';
          const studentName = item.first_name + ' ' + item.last_name;
          const dataArr = [studentName, item.gender, item.date_of_birth, item.class.name, item.class.grade.name, status];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'Teacher':
        const showTeacherHeaders = ['Teacher name', 'Key subject', 'Email address', 'Username', 'Status'];
        csv = csv.concat(showTeacherHeaders.join(','));
        data.forEach((item) => {
          if (item.role?.name === 'Teacher'){
            const status = (item.active === true) ? 'Active' : 'Archived';
            const dataArr = [item.name, item.key_subject?.name, item.contact?.email, item.username, status];
            csv = csv.concat(dataArr.join(','));
          }
        });
        this.downloadFile(section, csv);
        break;
      case 'Grades':
        const showGradeHeaders = ['Project grades', 'Ref. year'];
        csv = csv.concat(showGradeHeaders.join(','));
        data.grades.forEach((item) => {
          const dataArr = [item.name, item.year.name];
          csv = csv.concat(dataArr.join(','));
        });

        const showSubjectHeaders = ['Project Subjects'];
        csv = csv.concat(showSubjectHeaders.join(','));
        data.subjects.forEach((item) => {
          const dataArr = [item.name];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
      case 'GradeList':
        const showGradelistHeaders = ['Grade', 'Classes', 'Students', 'Subjects', 'Teachers'];
        csv = csv.concat(showGradelistHeaders.join(','));
        data.forEach((item) => {
          let classItems = '';
          let subjectItems = '';
          if (item.classes){
            classItems =  '"' + item.classes + '"';
          }
          if (item.subjects){
            subjectItems = '"' + item.subjects + '"';
          }
          const dataArr = [item.name, classItems, item.studentCount, subjectItems, item.teacherCount];
          csv = csv.concat(dataArr.join(','));
        });
        this.downloadFile(section, csv);
        break;
    }

  }

  /* Download content csv */
  private downloadContentCsv(data, section, type){
    let csv = new Array();
    let showAllContentHeaders = new Array();
    const loggedUserData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (loggedUserData.role.name === 'GeneralAdmin'){
      showAllContentHeaders = ['Content', 'Topic', 'Year', 'Subject', 'Language', 'Source', 'Type', 'Status'];
    } else {
      showAllContentHeaders = ['Content', 'Topic', 'Grade', 'Subject', 'Language', 'Source', 'Type', 'Status'];
    }
    csv = csv.concat(showAllContentHeaders.join(','));
    data.forEach((item) => {
      let yearData = '';
      if (loggedUserData.role.name === 'GeneralAdmin'){
        yearData = item.start_year.name + ' - ' + item.end_year.name;
      } else {
        yearData = item.start_grade.name + ' - ' + item.end_grade.name;
      }
      if (type === 'all'){
        const dataArr = [
                          item.title,
                          item.topic.name,
                          yearData,
                          item.subject.name,
                          item.language.name,
                          item.source.name,
                          item.media_type,
                          item.status
                        ];
        csv = csv.concat(dataArr.join(','));
      } else if (type === 'fav'){
        if (item.favorite){
          const dataArr = [
                            item.title,
                            item.topic.name,
                            yearData,
                            item.subject.name,
                            item.language.name,
                            item.source.name,
                            item.media_type,
                            item.status
                          ];
          csv = csv.concat(dataArr.join(','));
        }
      }
    });
    this.downloadFile(section, csv);
  }
  /* Download csv file */
  private downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' });
    const date = new Date();
    const timestamp = date.getTime();
    saveAs(blob, section + timestamp + '.csv');
  }

  /* This function directly creates object array to csv */
  private objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }

  /* Fetch keys from object to use as csv header */
  private objectToCsvHeader(data: any){
    const header = Object.keys(data).join(',');
    return header;
  }

  /* Fetch values from object to use as csv content */
  private objectToCsvContent(data: any){
    const bodyArr = Object.values(data);
    bodyArr.forEach( (item: any, index) => {
      if (item && typeof item === 'object'){
        bodyArr[index] = item.name;
      } else if (item && typeof item === 'string' && item.indexOf(',') !== -1){
        item = '"' + item + '"';
        bodyArr[index] = item;
      }
    });
    const body = bodyArr.join(',');
    return body;
  }
}
